import classNames from 'classnames';

export default function Container({ children, utilClasses }) {
  return (
    <div className={classNames('mx-auto h-full', utilClasses)}>
      {children}
    </div>
  );
}
